import { useState, useCallback } from 'react';
import { InputProps } from '../components';

export const useInput = (initialValue = '', transformValue?: (value?: string) => string) => {
	const [value, setValue] = useState(initialValue);

	const handleChange = useCallback(
		(value: string) => {
			setValue(transformValue ? transformValue(value) : value);
		},
		[transformValue],
	);

	const reset = useCallback(() => setValue(initialValue), [initialValue]);

	const onBlur: Pick<InputProps, 'onBlur'>['onBlur'] = transformValue
		? () => transformValue(value)
		: undefined;

	return {
		value,
		onChangeText: handleChange,
		reset,
		onBlur,
	};
};
